import React from "react";

export default function GuardrailsPanel({ stepData }) {
  if (!stepData) {
    return <div className="lcx-g-empty">Guardrails will activate when the demo runs…</div>;
  }
  return (
    <div className="lcx-guardrails">
      {stepData.guardrails.map((g) => (
        <div key={g.name} className="lcx-gcard active">
          <span className="g-icon">{g.icon}</span>
          <div>
            <div className="g-name">{g.name}</div>
            <div className="g-reg">{g.reg}</div>
          </div>
        </div>
      ))}
    </div>
  );
}